import { render, staticRenderFns } from "./CasePeopleTable.vue?vue&type=template&id=1ba31268"
import script from "./CasePeopleTable.vue?vue&type=script&lang=js"
export * from "./CasePeopleTable.vue?vue&type=script&lang=js"
import style0 from "./CasePeopleTable.vue?vue&type=style&index=0&id=1ba31268&prod&lang=css"
import style1 from "./CasePeopleTable.vue?vue&type=style&index=1&id=1ba31268&prod&lang=scss&scope=true"
import style2 from "./CasePeopleTable.vue?vue&type=style&index=2&id=1ba31268&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports